import { defineComponent, h } from 'vue'
import QItem from 'quasar/src/components/item/QItem.js';

export default defineComponent({
  name: 'QItemStandalone',
  setup (props, { slots, attrs }) {
    return () => {
      return h(QItem, { ...props, role: null, ...attrs }, slots?.default)
    }
  }
})
